import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import FooterToolBar from '../../../components/tool/FooterToolBar.vue';
import VueColor from "vue-color";
import { getWaterMarking, editWatermarking, getPreviewImg } from '@/services/systemsetting.js';
export default {
  components: {
    FooterToolBar: FooterToolBar,
    "sketch-picker": VueColor.Sketch
  },
  i18n: require("./../i18n-basucSettings"),
  watch: {
    // "form.offset": {
    //     handler(newVal,oldval) {
    //         clearTimeout(this.timeout)
    //         this.timeout = setTimeout(() => {
    //         this.handleChangeOffset(newVal)
    //         }, 500)
    //     }
    // }
  },
  data: function data() {
    return {
      loadingSave: false,
      canUpload: true,
      type: 0,
      color: '#F1A5A5',
      previewImg: '',
      uploadImg: '',
      preRelativelyPath: '',
      uploadRelativelyPath: '',
      visibleColor: false,
      uploadLimit: 5,
      uploading: false,
      timeout: null,
      form: {
        watermarkSwitch: null,
        watermarkType: 1,
        position: 0,
        offset: 10,
        font: 0,
        waterMarkFontStyle: 2,
        fontColor: '#F1A5A5',
        xOffset: 10,
        yOffset: 10,
        rotation: '',
        alpha: 2,
        content: '',
        fontSize: 12,
        textPosition: 3
      },
      positionList: [{
        value: 0,
        title: this.$t('picWatermark.positionList1')
      }, {
        value: 1,
        title: this.$t('picWatermark.positionList2')
      }, {
        value: 2,
        title: this.$t('picWatermark.positionList3')
      }, {
        value: 3,
        title: this.$t('picWatermark.positionList4')
      }, {
        value: 4,
        title: this.$t('picWatermark.positionList5')
      }, {
        value: 5,
        title: this.$t('picWatermark.positionList6')
      }, {
        value: 6,
        title: this.$t('picWatermark.positionList7')
      }, {
        value: 7,
        title: this.$t('picWatermark.positionList8')
      }, {
        value: 8,
        title: this.$t('picWatermark.positionList9')
      }],
      textPosition: [{
        value: 0,
        title: this.$t('picWatermark.positionList2')
      }, {
        value: 1,
        title: this.$t('picWatermark.positionList7')
      }, {
        value: 2,
        title: this.$t('picWatermark.positionList4')
      }, {
        value: 3,
        title: this.$t('picWatermark.positionList9')
      }],
      fontList: [{
        value: 0,
        title: this.$t('picWatermark.fontList1')
      }],
      fontType: [{
        value: 1,
        title: this.$t('picWatermark.fontType1')
      }, {
        value: 2,
        title: this.$t('picWatermark.fontType2')
      }, {
        value: 3,
        title: this.$t('picWatermark.fontType3')
      }],
      transparencyList: [{
        value: 0,
        title: '0.1'
      }, {
        value: 1,
        title: '0.2'
      }, {
        value: 2,
        title: '0.3'
      }, {
        value: 3,
        title: '0.4'
      }, {
        value: 4,
        title: '0.5'
      }, {
        value: 5,
        title: '0.6'
      }, {
        value: 6,
        title: '0.7'
      }, {
        value: 7,
        title: '0.8'
      }, {
        value: 8,
        title: '0.9'
      }, {
        value: 9,
        title: this.$t('picWatermark.noTransparent')
      }],
      rules: {
        content: [{
          required: true,
          message: this.$t('picWatermark.rule'),
          trigger: ['change', 'blur']
        }]
      },
      action: '',
      updateData: {},
      getPreviewImgLoading: false
    };
  },
  mounted: function mounted() {
    this.action = process.env.VUE_APP_API_BASE_URL + "/common/upload/";
    this.initData();
  },
  methods: {
    save: function save() {
      var _this = this;
      if (this.form.watermarkType == 1 && !this.uploadImg) {
        return;
      } else {
        this.$refs.warterMarkRef.validate(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(valid) {
            var params, newParams, res;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  console.log(valid);
                  if (!valid) {
                    _context.n = 4;
                    break;
                  }
                  _this.loadingSave = true;
                  params = _this.getParams();
                  newParams = params.waterMark;
                  newParams.byImg.img = _this.uploadRelativelyPath;
                  newParams.byImg.previewImg = _this.preRelativelyPath;
                  _context.p = 1;
                  _context.n = 2;
                  return editWatermarking(newParams);
                case 2:
                  res = _context.v;
                  if (res.data.code == 200) {
                    setTimeout(function () {
                      _this.$message.success(_this.$t('public.saveSuccessfully'));
                    }, 500);
                  }
                case 3:
                  _context.p = 3;
                  setTimeout(function () {
                    _this.loadingSave = false;
                  }, 500);
                  return _context.f(3);
                case 4:
                  return _context.a(2);
              }
            }, _callee, null, [[1,, 3, 4]]);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }
    },
    initData: function initData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, initData, newForm, random;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getWaterMarking();
            case 1:
              res = _context2.v;
              console.log(res);
              if (res.data.code == 200) {
                initData = _.cloneDeep(res.data.data);
                _this2.form.watermarkType = res.data.data.type;
                _this2.form.watermarkSwitch = res.data.data.switch;
                newForm = _objectSpread(_objectSpread({}, initData.byImg), initData.byText);
                Object.assign(_this2.form, newForm);
                _this2.uploadImg = initData.urlpath && initData.byImg.img ? initData.urlpath + initData.byImg.img : '';
                random = Math.ceil(Math.random() * 100000);
                _this2.previewImg = initData.urlpath && initData.byImg.previewImg ? initData.urlpath + initData.byImg.previewImg + '?' + random : '';
                _this2.form.position = initData.byImg.position, _this2.form.textPosition = initData.byText.position;
                _this2.form.watermarkType = 1;
                _this2.uploadRelativelyPath = initData.byImg.img;
                _this2.preRelativelyPath = initData.byImg.previewImg;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    changeWatermarkType: function changeWatermarkType(e) {
      this.$refs.warterMarkRef.resetFields();
      this.form.watermarkType = e.target.value;
      this.uploadImg = '';
      this.previewImg = '';
    },
    beforeUpload: function beforeUpload(file) {
      this.updateData = this.getParams();
      this.updateData.waterMark = JSON.stringify(this.updateData.waterMark);
      var isPng = file.type === 'image/png';
      if (!isPng) {
        // this.$message.error(this.$t('public.pictureType'));
        this.$message.error(this.$t('picWatermark.error1'));
      }
      var isLt = file.size / 1024 / 1024 < this.uploadLimit;
      if (!isLt) {
        // this.$message.error(this.$t('public.pictureMax',{uploadLimit: this.uploadLimit}));
        this.$message.error(this.$t('picWatermark.error2'));
      }
      this.canUpload = isPng && isLt;
      return isPng && isLt;
    },
    getBase64: function getBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    handleChange: function handleChange(info) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var imageUrl, random;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(info.file.status === 'uploading')) {
                _context3.n = 1;
                break;
              }
              _this3.uploading = true;
              return _context3.a(2);
            case 1:
              if (!(info.file.status === 'done')) {
                _context3.n = 3;
                break;
              }
              if (!(info.file.response.code == 200)) {
                _context3.n = 3;
                break;
              }
              _context3.n = 2;
              return _this3.getBase64(info.file.originFileObj);
            case 2:
              imageUrl = _context3.v;
              _this3.uploadImg = imageUrl;
              _this3.uploadRelativelyPath = info.file.response.data.uploadfilepath;
              random = Math.ceil(Math.random() * 100000);
              _this3.previewImg = info.file.response.data.urlpath + info.file.response.data.previewImg + '?' + random;
              _this3.preRelativelyPath = info.file.response.data.previewImg;
              _this3.uploading = false;
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    // 图片位置改变    
    changePosition: function changePosition(e) {
      this.getPreviewPic();
    },
    //   handleChangeOffset(newVal) {
    //         if(newVal == '') {
    //             return false
    //         }
    //         console.log(newVal)
    //   },
    // 图片偏移量改变
    changePicOffset: function changePicOffset() {
      this.getPreviewPic();
    },
    // 文字内容改变
    changeTextContent: function changeTextContent(e) {
      console.log('文字内容', this.form.content);
    },
    // 文字字体改变
    changeTextFont: function changeTextFont() {
      console.log('文字字体', this.form.font);
    },
    // 文字字体大小改变
    changeTextFontsize: function changeTextFontsize() {
      console.log('文字大小', this.form.fontSize);
    },
    // 文字样式
    changeTextStyle: function changeTextStyle() {
      console.log('文字样式', this.form.waterMarkFontStyle);
    },
    // 字体颜色改变
    handleUpdate: function handleUpdate(e) {
      this.form.fontColor = e.hex;
    },
    // 文字位置
    changeTextPosition: function changeTextPosition() {},
    // 横向偏移量
    changeTextOffsetW: function changeTextOffsetW() {
      console.log('横向偏移量', this.form.xOffset);
    },
    // 纵向偏移量
    changeTextOffsetH: function changeTextOffsetH() {
      console.log('纵向偏移量', this.form.yOffset);
    },
    // 透明度
    changeTextTransparency: function changeTextTransparency() {
      console.log('透明度', this.form.alpha);
    },
    // 旋转角度
    changeTextRotate: function changeTextRotate() {
      console.log('旋转角度', this.form.rotation);
    },
    getParams: function getParams() {
      var params = {
        type: 9,
        waterMark: {
          switch: this.form.watermarkSwitch,
          type: this.form.watermarkType,
          byImg: {
            img: '',
            position: this.form.position,
            offset: this.form.offset,
            previewImg: ''
          },
          byText: {
            content: this.form.content,
            font: this.form.font,
            fontSize: this.form.fontSize,
            fontStyle: this.form.fontStyle,
            fontColor: this.form.fontColor,
            position: this.form.textPosition,
            xOffset: this.form.xOffset,
            yOffset: this.form.yOffset,
            alpha: this.form.alpha,
            rotation: this.form.rotation
          }
        }
      };
      return params;
    },
    // 获取预览图的方法
    getPreviewPic: function getPreviewPic() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var fd, params, res, random;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              fd = new FormData();
              params = _this4.getParams();
              params.waterMark.byImg.img = _this4.uploadRelativelyPath;
              console.log(_this4.uploadRelativelyPath);
              params.waterMark.byImg.previewImg = _this4.preRelativelyPath;
              fd.append('file', '');
              fd.append('type', 9);
              fd.append('waterMark', JSON.stringify(params.waterMark));
              if (!_this4.getPreviewImgLoading) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _this4.getPreviewImgLoading = true;
              _context4.p = 2;
              _context4.n = 3;
              return getPreviewImg(fd);
            case 3:
              res = _context4.v;
              if (res.data.code == 200) {
                random = Math.ceil(Math.random() * 100000);
                _this4.previewImg = res.data.data.urlpath + res.data.data.previewImg + '?' + random;
                _this4.preRelativelyPath = res.data.data.previewImg;
              }
            case 4:
              _context4.p = 4;
              _this4.getPreviewImgLoading = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, null, [[2,, 4, 5]]);
      }))();
    }
  }
};